@if (_active) {
  <kendo-window (close)="_closeForm()" title="Add New Record" (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm reportForm">
    <form [formGroup]="editForm" (keydown.enter)="$event.preventDefault()">
      <div class="row addNewForecastForm">
        <!-- <div class="col-12">
        <div class="bordered_sections">
          <div class="col-12 import_title">Follow the Steps</div>
          <kendo-stepper [steps]="_steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false">
          </kendo-stepper>
        </div>
      </div> -->
      <div class="col-12">
        <div class="row stepsRowMargin">
          <div class="col-12 col-lg-6 stepsColPadding">
            <div class="row stepsRowMargin">
              <div class="col-12 stepsColPadding">
                <div class="row">
                  <div class="col-12">
                    <p class="step_title">Catalog Info</p>
                  </div>
                  <div class="col-12">
                    <div class="bordered_sections_special min-height-section"
                      [class.active-step-report]="currentStep === 0">
                      <!--All Sites DropDown-->
                      <div class="row">
                        <div class="col-12">
                          <!--All Sites DropDown-->
                          <sites-dropdown #kendo_combo_SiteCode [(ngModel)]="_siteSelected"
                            (siteChanged)="_handleSitesChange($event)" [ngModelOptions]="{standalone: true}"
                            [textField]="'code'" [valueField]="'id'"
                            class="MultiSiteCustomComboBox bordered fullavailableWidth"
                            [layout]="'form-group'"
                            [labelText]="'Site Code'">
                          </sites-dropdown>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label class="control-label trl" for="reportName">
                              Catalog
                              Name
                            </label>
                            <input #kendo_input_Report_Name type="text" class="k-textbox writebox fullavailableWidth"
                              formControlName="reportName" placeholder="Enter Catalog Name"
                              (keyup.enter)="_ReportNameChange()" (keydown.Tab)="_ReportNameChange()" required />
                            </div>
                            <div class="form-group">
                              <label class="control-label trl" for="reportCategory">
                                Select
                                Category
                              </label>
                              <kendo-combobox #kendo_combo_Report_Category [data]="categories" [suggest]="true"
                                (valueChange)="GetFieldsByCategory($event)" class="bordered fullavailableWidth"
                                [textField]="'reportCategoryname'" [valueField]="'reportCategoryid'"
                                placeholder="Select Category" formControlName="reportCategory" required>
                              </kendo-combobox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special min-height-section skipsectionpadding"
                        [class.active-step-report]="currentStep === 1">
                        <div class="skipSpan" [class.skipButtonView]="currentStep === 1" (click)="_skipStepOrientation()">
                          skip
                          <span>
                            <img class="skipimage" [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                          </span>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <div>
                                <label class="control-label trl" for="addLogo">
                                  Include
                                  Logo
                                </label>
                                <kendo-combobox #kendo_Combo_Include_Logo [data]="LogoData" [suggest]="true"
                                  class="fullavailableWidth" formControlName="addLogo" (valueChange)="getLogoChange()">
                                </kendo-combobox>
                              </div>
                            </div>
                            <div class="form-group">
                              <div>
                                <label class="control-label trl" for="addAddress">
                                  Include
                                  Address
                                </label>
                                <kendo-combobox #kendo_Combo_Include_Address [data]="AddressData" [suggest]="true"
                                  class="fullavailableWidth" formControlName="addAddress"
                                  (valueChange)="includeAddressChange()">
                                </kendo-combobox>
                                <!-- <input type="checkbox" formControlName="addAddress"
                                kendoCheckBox /> -->
                              </div>
                            </div>
                            <div class="form-group">
                              <div>
                                <label class="control-label trl" for="orientation">Orientation</label>
                                <kendo-combobox #kendo_Combo_Orientation [data]="OrientationData" [suggest]="true"
                                  class="fullavailableWidth" formControlName="orientation"
                                  (valueChange)="orientationChange()">
                                </kendo-combobox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row stepsRowMargin">
                <div class="col-12 col-md-7 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      @if (fields) {
                        <asap-fields-select-from-boxes class="select-boxes" [fields]="fields"
                          [selectedFields]="selectedFields" (selectedFieldsOutput)="_onchangeSelectedFields($event)"
                          [displayFieldName]="'title'" [title]="'Fields'" [fullWidth]="true" [max10Items]="true"
                          [showFilters]="false" [withPrimary]="false">
                        </asap-fields-select-from-boxes>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-5 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title">
                        Select Groups<span class="stepDescription">(Optional)</span>
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special_small minHeightSection"
                        [class.active-step-report]="currentStep === 3">
                        <div class="skipSpan" [class.skipButtonView]="currentStep === 3" (click)="_skipStep()">
                          skip
                          <span>
                            <img class="skipimage" [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                          </span>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <label class="control-label trl sgcb" for="groupBy">Group By</label>
                              <kendo-combobox #kendo_combo_groupby [data]="selectedFieldsWithoutBarcodeImage"
                                [textField]="'title'" formControlName="groupBy" [valueField]="'field'"
                                (selectionChange)="selectGroupHeader($event)" class="reportCombobox_sgcb" placeholder="">
                              </kendo-combobox>
                            </div>
                            <div class="form-group">
                              <label class="control-label trl sgcb left" for="groupHeader">Group Header</label>
                              <div #kendo_multiselect_wrapper class="customMultiSelectList customMultiSelectListReports">
                                <kendo-multiselect [summaryTagAfter]="0" #kendo_multiselect
                                  class="customMultiSelect" formControlName="groupHeader" placeholder="Select Header"
                                  [autoClose]="true" [(ngModel)]="_selectedGroupHeaders"
                                  (valueChange)="_groupheaderChange($event)" (document:click)="_multiSelectClose($event)"
                                  [itemDisabled]="_itemDisabled" [data]="selectedFieldsWithoutBarcodeImage"
                                  textField="title" valueField="field">
                                  <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <input type="checkbox" class="k-checkbox" [checked]="_isItemSelected(dataItem.id)">
                                    <label class="k-checkbox-label">
                                      {{ dataItem.title }}
                                    </label>
                                  </ng-template>
                                </kendo-multiselect>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 stepsColPadding">
              <div class="row stepsRowMargin">
                <div class="col-12 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title">Catalog Preview</p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special_right fullminHeightSection"
                        [class.active-step-report]="currentStep === 4">
                        <!-- <div *ngIf="currentStep !== 4" class="report-overlay"></div> -->
                        <div class="row rowcenteredDisplay">
                          <div class="col-12">
                            <div class="reportImageContainer">
                              @if (previewReport) {
                                <report-viewer [isCatalog]="true" [reportObject]="previewReportObj"
                                  [barcodeModel]="_model" [definitionOnly]="definitionOnly" [reportParent]="'custom'"
                                  (returnDefinition)="saveReportDefinition($event)" (closeForm)="_closeForm()">
                                </report-viewer>
                              }
                              <!-- <report-viewer *ngIf="previewReport"
                              [reportObject]="previewReportObj"
                              [definitionOnly]="definitionOnly"
                              [reportParent]="'custom'"
                              (returnDefinition)="saveReportDefinition($event)">
                            </report-viewer> -->
                            @if (!previewReport) {
                              <img class="reportDefaultImg"
                                [src]="'/assets/menu/'+ _theme +'/report-image.svg'" />
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (_invalidForm) {
      <asap-forms-validation-summary [form]="_currentForm" [page]="'customReport'"
        [listToValidate]="selectedFields">
      </asap-forms-validation-summary>
    }
    <div class="row">
      <div class="col-12" style="margin-top:10px">
        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
          <button kendoButton class="steps_buttons_class"
            (click)="save('close')">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
            <span>save and close</span>
          </button>
        }
        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
          <button kendoButton class="steps_buttons_class"
            (click)="save('edit')">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
            <span>save and edit</span>
          </button>
        }
        @if (currentStep >= 3 || (selectedFields && selectedFields.length > 0)) {
          <button kendoButton class="steps_buttons_class"
            (click)="save('process')">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
            <span>save and run</span>
          </button>
        }
        <!-- <button kendoButton class="steps_buttons_class"
        *ngIf="currentStep >= 3 || (selectedFields && selectedFields.length > 0)" (click)="preview()">
        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/view-icon-green.svg'" />
        <span>Preview</span>
      </button> -->
      <!-- <button kendoButton class="steps_buttons_class" *ngIf="currentStep < 4" (click)="nextStep()">
      <img class="backimage" [src]="'/assets/menu/'+ _theme +'/next-icon.svg'" />
      <span>Next</span>
    </button>
    <button kendoButton class="steps_buttons_class" *ngIf="currentStep > 0" (click)="previousStep()">
      <img class="backimage" [src]="'/assets/menu/'+ _theme +'/back-icon.svg'" />
      <span>Back</span>
    </button> -->
  </div>
</div>
</form>
</kendo-window>
}
